import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from '../../data.service';
import { GlobalConstant } from '../../constants/global-constant';
import { UrlConstant } from '../../constants/url-constant';
import { AppData } from '../../constants/app-data';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  home = GlobalConstant.home;
  homeLink = "/home";
  public isAuthenticated: boolean;
  //public isLeftNavActive: boolean;
  //isAuthenticated = false;
  name: string;
  
  constructor(private router: Router, public appData: AppData, private dataService: DataService) {
  	// Subscribe here, this will automatically update 
  	//console.log('HeaderComponent constructor');
    this.validateIfAlreadyLoggedIn();
   
   }

	async validateIfAlreadyLoggedIn() {
		// "isUserLoggedIn" whenever a change to the subject is made.
        var apiKey = this.dataService.getApiKeyHeaderFromLocalStorage();
        //console.log('apiKey:' + apiKey);
        if(apiKey === undefined || apiKey.length === 0) return;
        
    	var reqBody = {"token":apiKey};
      	await this.dataService.sendPostRequestWithBody(UrlConstant.apiValidateLogin ,reqBody).toPromise().then((data: any)=>{
	      //console.log('apiValidateLogin: response received:'+data);
	      //this.message = data;
	      if("SUCCESS" === data.statusCode){
	      	//console.log("apiValidateLogin => success code");
	      	//this.dataService.getLoggedInUserData({'userId': data.statusMessage});
	      	this.dataService.getLoggedInUserDataWithAllPrivileges({'userId': data.statusMessage});
	      	//this.appData.isAuthenticated.next(true);
	      	if(data.loginUserStatus === "FORCE-PASSWORD-CHANGE"){
	      		//this.router.navigate(['/changePassword', { 'userId': username, 'token': data.token }]);
	      		return;
	      	}
	      	
	      } else if("FAIL" === data.statusCode && "Invalid Token" === data.statusMessage){
	      	this.dataService.removeApiKeyHeaderFromLocalStorage();
      		this.dataService.navigateToUrl('/home');
	      } else {
	      	this.dataService.navigateToUrl('/home');
	      }
	      
	    });
	    
	}
	
  ngOnInit(): void {
  	 //console.log('HeaderComponent ngOnInit');
  	 //Because of below line, if appData.isAuthenticated value changes any number of times,
  	 // it will reflect in this.isAuthenticated. And then UI will get updated accordingly.
	 this.appData.isAuthenticated.subscribe(message=> this.isAuthenticated = message);
	 //this.appData.isLeftNavActive.subscribe(message=> this.isLeftNavActive = message);
	 this.appData.user.subscribe(userData=> {
		 //console.log("header-userdata::"+userData)
		 this.name = (userData !== null)? userData.firstName:""
		 });
		 
  }
 
  public redirectToHome(){
	var uId = this.dataService.getFromLocalStorage(GlobalConstant.KEY_LOCAL_STORAGE_VENDOR_UNIQUE_ID);
    if(uId!=null && uId!=undefined && uId!=''){
    	//this.homeLink += ";" + GlobalConstant.KEY_URL_PARAM_VENDOR_UNIQUE_ID + "=" + uId; 
    	var param ={};
    	param[GlobalConstant.KEY_URL_PARAM_VENDOR_UNIQUE_ID] = uId; 
    	this.router.navigate(['/home', param]);
    } else {
		this.dataService.navigateToUrl('/home');
	}
    
  //  this.dataService.navigateToUrl(this.homeLink);
  }
  
  public logout(){
  	if(this.appData.userId === ""){
  		//console.log("Nobody logged In");
  		return;
  	} else {
  		//console.log(this.appData.userId + " logging Out");
  	}
  	this.dataService.logout("");
  	this.isAuthenticated = false;
  	/*var reqBody = {"userId": this.appData.userId};
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiLogout ,reqBody).subscribe((data: any)=>{
      //console.log(data);
      if("SUCCESS" === data.statusCode){
      		//this.appData.loginInvalid.next(true);
      		this.appData.userId = "";
      		this.appData.isAuthenticated.next(false);
      		this.appData.isLeftNavActive.next(false);
      		this.appData.leftNavMenuDrawer.subscribe(leftMenuDrawer=> leftMenuDrawer.close());
      		this.isAuthenticated = false;
      		this.dataService.removeApiKeyHeaderFromLocalStorage();
      		this.dataService.navigateToUrl('/home');
      }
    });*/
  }

	public toggleMenu(){
		this.appData.leftNavMenuDrawer.subscribe(navDrawer=> navDrawer.toggle() );
	}
	
	public toggleRightMenu(){
		this.appData.rightNavMenuDrawer.subscribe(navDrawer=> navDrawer.toggle() );
	}	
	
}
